import { Component } from '@theme/component';

/**
 * A custom element that manages product delivery country selection.
 */
export default class ProductDelivery extends Component {
  connectedCallback() {
    super.connectedCallback();
    
    this.select = this.querySelector('[data-product-delivery-el="select"]');
    this.contents = this.querySelectorAll('[data-product-delivery-el="content"]');

    if (this.select) {
      const defaultCountry = this.dataset.defaultCountry;
      if (defaultCountry) this.select.value = defaultCountry;
      this.select.addEventListener('change', () => this.onSelectChange());
      this.onSelectChange();
    }
  }

  onSelectChange() {
    console.log('Select changed to:', this.select.value);
    if (!this.select) return;
    const selectedCountry = this.select.value;
    
    this.contents.forEach((content) => {
      const isMatch = content.dataset.country === selectedCountry;
      console.log('Content:', content.dataset.country, 'isMatch:', isMatch);
      content.setAttribute('aria-expanded', isMatch ? 'true' : 'false');
    });
  }
}

if (!customElements.get('product-delivery')) {
  customElements.define('product-delivery', ProductDelivery);
}
